@if (isLoading) {
  <div class="flex justify-center items-center h-64">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}
@if (!isLoading) {
  <div class="rounded-3xl shadow-2xl p-4 rounded-lg">
    <div class="w-full max-w-md mx-auto p-6">
      <h2 class="mb-4 titre2 text-center">{{ 'CONTENUS_MANAGEMENT.CHOIX_LANGUE' | translate }}</h2>
      <h4 class="mb-4 titre4 text-center">{{ 'CONTENUS_MANAGEMENT.INFORMATION_CHOIX_LANGUE' | translate }}</h4>
      <form (ngSubmit)="onSubmit()"  #languageForm="ngForm">
        <div class="flex justify-center items-center flex-wrap gap-6">
          <label class="flex items-center space-x-2">
            <input type="radio" name="language" [(ngModel)]="selectedLanguage" value="fr" class="accent-red-500" required />
            <span>{{ 'CONTENUS_MANAGEMENT.LANGUE_FRANCAIS' | translate }}</span>
          </label>
          <label class="flex items-center space-x-2">
            <input type="radio" name="language" [(ngModel)]="selectedLanguage" value="en" class="accent-red-500" />
            <span>{{ 'CONTENUS_MANAGEMENT.LANGUE_ANGLAIS' | translate }}</span>
          </label>
          <label class="flex items-center space-x-2">
            <input type="radio" name="language" [(ngModel)]="selectedLanguage" value="es" class="accent-red-500" />
            <span>{{ 'CONTENUS_MANAGEMENT.LANGUE_ESPAGNOL' | translate }}</span>
          </label>
        </div>
        <div class="flex justify-end mt-6 space-x-4 gap-1">
          <button type="button" (click)="onCancel()" class="btn-secondary-novo">{{ 'CONTENUS_MANAGEMENT.CANCEL' | translate }}</button>
          <button type="submit"  [disabled]="selectedLanguage == null" class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">{{ 'CONTENUS_MANAGEMENT.CONFIRMER' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
}


